import { Action } from 'redux';
import { createActions, handleActions, combineActions, ActionFunctionAny } from 'redux-actions';
import { IWebsocketMessage, TYPE, ISubscription } from 'types';

export interface WebsocketState {
  subscriptions: ReadonlyArray<ISubscription>;
  messages: Array<IWebsocketMessage | { side: TYPE }>;
  connected: boolean;
}

const defaultState = {
  subscriptions: [],
  messages: [],
  connected: false
} as WebsocketState;

export const actions: { [actionName: string]: ActionFunctionAny<Action<any>> } = createActions({
  STORE_SENT_MESSAGE: (message: IWebsocketMessage) => ({
    message,
    type: TYPE.SENT
  }),
  STORE_RECEIVED_MESSAGE: (message: IWebsocketMessage) => ({
    message,
    type: TYPE.RECEIVED
  }),
  SEND: undefined,
  CONNECTION_SUCCESS: () => ({ connected: true }),
  CONNECTION_LOST: () => ({ connected: false }),
  SUBSCRIBE_TO_WEBSOCKET: ({ key, handler }: { key: string; handler: any }) => ({
    key,
    handler
  }),
  UNSUBSCRIBE_FROM_WEBSOCKET: ({ key }: { key: string }) => ({ key }),
  ON_MESSAGE: undefined
});

export const reducer = handleActions(
  {
    [combineActions(
      actions.storeReceivedMessage as unknown as string,
      actions.storeSentMessage as unknown as string
    ) as any]: (state: any, { payload: { message, type } }) => ({
      ...state,
      messages: [...state.messages, { ...message, type }]
    }),
    [combineActions(
      actions.connectionSuccess as unknown as string,
      actions.connectionLost as unknown as string
    ) as any]: (state: WebsocketState, { payload: { connected } }) => ({
      ...state,
      connected
    }),
    [actions.subscribeToWebsocket as unknown as string]: (state: WebsocketState, { payload: { key, handler } }) => ({
      ...state,
      subscriptions: [...state.subscriptions, { key, handler }]
    }),
    [actions.unsubscribeFromWebsocket as unknown as string]: (state: WebsocketState, { payload: { key } }) => {
      const subscriptions = [...state.subscriptions];
      const index = subscriptions.findIndex(sub => sub.key === key);
      if (index !== -1) {
        subscriptions.splice(index, 1);
        return {
          ...state,
          subscriptions
        };
      }
      return state;
    }
  },
  defaultState
);
